import { wapiTransferRepository, getTransfer, acceptTransfer, rejectTransfer } from '@/core/transfer'

export function provideTransferUseCases () {
  const repo = wapiTransferRepository()

  return {
    getTransfer: getTransfer(repo),
    acceptTransfer: acceptTransfer(repo),
    rejectTransfer: rejectTransfer(repo)
  }
}
